import React, { useState } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { useTranslation } from 'react-i18next';

export const LanguageSelect = () => {
    const { i18n } = useTranslation();
    const [select, setSelect] = useState(i18n.language.toUpperCase() || 'US');

    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang);
        // console.log('Language changed: ', lang)
    };

    const onSelect = (code: string) => {
        setSelect(code);
        changeLanguage(code.toLowerCase());
    };

    return (
        <ReactFlagsSelect
            showSelectedLabel={true}
            showSecondarySelectedLabel={true}
            selectedSize={12}
            optionsSize={12}
            showOptionLabel={true}
            countries={['US', 'DE', 'GB', 'FR', 'ES']}
            customLabels={{ US: 'US', DE: 'DE', GB: 'EN', FR: 'FR', ES: 'ES' }}
            placeholder="Select Language"
            selected={select === 'DE-DE' ? 'DE' : select}
            onSelect={onSelect}
        />
    );
};
